import Workspace from './Workspace.vue'

export default Workspace
